/*
 * File: UpdateCourseCompletionDate.ts
 * Author: Austin Robinson
 * Date Created: 4/27/2025
 * Copyright (c) DrivingDoc 2025
 */

import { createMutation } from "react-query-kit";
import { privateApi } from "api";

export interface UpdateCourseCompletionDateParams {
    id: string;
    completionDate: string; // ISO 8601 date string
}

export interface UpdateCourseCompletionDateResult {
    tenant_id: string;
    id: string;
    student_user_id: string;
    course_section_id: string;
    student_charge_id?: string | null;
    package_course_package_id?: string | null;
    package_course_course_id?: string | null;
    course_policy_course_id: string;
    course_policy_updated_at: Date;
    course_enrollment_criteria_course_id: string;
    course_enrollment_criteria_updated_at: Date;
    course_self_schedule_criteria_course_id?: string | null;
    course_self_schedule_criteria_updated_at?: Date | null;
    course_completion_criteria_course_id: string;
    course_completion_criteria_updated_at: Date;
    secure_seat_mode?: "at_time_of_enrollment" | "when_deposit_paid" | "when_full_cost_paid" | null;
    seat_secured_at?: Date | null;
    seat_secured_by?: string | null;
    enrolled_at: Date;
    created_by?: string | null;
    completed_at?: Date | null;
    tenant_location_id?: string | null;
    performance_time_included?: string | null;
    observation_time_included?: string | null;
    requisite_group: number;
    became_eligible_at?: Date | null;
}


async function updateCourseCompletionDate({ id, completionDate }: UpdateCourseCompletionDateParams): Promise<UpdateCourseCompletionDateResult> {
    // make api call
    const result = await privateApi.patch(`${import.meta.env.VITE_API_BASE_URL}/courses/enrollments/${id}/completionDate`, {
        completionDate: completionDate,
    });

    // return the data object
    return result.data;
}

const useUpdateCourseCompletionDate = createMutation({
    mutationFn: async (variables: UpdateCourseCompletionDateParams) => updateCourseCompletionDate(variables),
});

export { updateCourseCompletionDate, useUpdateCourseCompletionDate };
